
import TrackerTable from './tracker-table.vue'

export default {
  components: {TrackerTable},
  props: {
    widget: {type: Object, required: true}
  },
  emits: ['after-leave'],
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    }
  }
}
